export class RecordingRequirementsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRecordingRequirements(params) {
    return this.#http.get('/api/recording-requirements', { params });
  }

  async getScopes(params) {
    return this.#http.get('/api/recording-requirements/scopes', { params });
  }

  async getScope({ id }) {
    return this.#http.get(`/api/recording-requirements/scopes/${id}`);
  }

  async createScope(body) {
    return this.#http.post('/api/recording-requirements/scopes', body);
  }

  async updateScope({ id, ...body }) {
    return this.#http.put(`/api/recording-requirements/scopes/${id}`, body);
  }

  async deleteScope({ id }) {
    return this.#http.delete(`/api/recording-requirements/scopes/${id}`);
  }
}
